import { Box, HStack, Spacer, VStack } from '@sgme/ui';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { BulkOrderInstructions } from '@/App/BulkOrder/BulkOrderInstructions.tsx';
import { BulkOrderStepper } from '@/App/BulkOrder/BulkOrderStepper.tsx';
import BulkOrderTables from '@/App/BulkOrder/BulkOrderTables/BulkOrderTables';
import { ImportInput } from '@/App/BulkOrder/ImportInput.tsx';
import { fixingBulkOrderIdsSelector, stopLossBulkOrderIdsSelector } from '@/store/bulkOrder/selectors.ts';
import { useAppSelector } from '@/store/hooks.ts';
import { selectActiveTabId } from '@/store/tabs/slice.ts';

export const BulkOrder = () => {
  const [step, setStep] = useState(1);
  const [hasErrorImporting, setHasErrorImporting] = useState(false);
  const [isImportingWithNoRight, setIsImportingWithNoRight] = useState<'fixing' | 'stopLoss' | undefined>();
  const tabId = useAppSelector(selectActiveTabId);

  const allStopLossBulkOrderIds = useAppSelector((state) => stopLossBulkOrderIdsSelector(state, tabId));
  const allFixingBulkOrderIds = useAppSelector((state) => fixingBulkOrderIdsSelector(state, tabId));

  return (
    <VStack fullWidth fullHeight className="flex-grow-1 bg-lvl4">
      <HStack flex="min" gap="12px" margin="24px" className="mb-3">
        <h3 className="col-6">
          <FormattedMessage id="bulkOrder.title" />
        </h3>

        <Spacer />
      </HStack>

      <div className="m-3">
        <BulkOrderStepper hasError={hasErrorImporting} step={step} />
      </div>

      <Box flex="expand" className="overflow-y-auto mb-5 pt-0" padding="24px">
        {(allStopLossBulkOrderIds && allStopLossBulkOrderIds.length > 0) ||
        (allFixingBulkOrderIds && allFixingBulkOrderIds.length > 0) ? (
          <BulkOrderTables
            allFixingBulkOrderIds={allFixingBulkOrderIds}
            allStopLossBulkOrderIds={allStopLossBulkOrderIds}
            isImportingWithNoRight={isImportingWithNoRight}
            setHasErrorImporting={setHasErrorImporting}
            setStep={setStep}
          />
        ) : (
          <>
            <BulkOrderInstructions />
            <div className="text-center bg-primary-alt">
              <ImportInput
                setStep={setStep}
                setHasErrorImporting={setHasErrorImporting}
                setIsImportingWithNoRight={setIsImportingWithNoRight}
                tabId={tabId}
              />

              {hasErrorImporting && (
                <div className="alert alert-discreet-danger text-start mt-1" role="alert">
                  <i className="icon icon-md icon-outlined me-2">info</i>
                  <FormattedMessage id="bulkOrder.import.error.message" />
                </div>
              )}
            </div>
          </>
        )}
      </Box>
    </VStack>
  );
};
